import React from 'react';
import ResetMutation from 'mutations/user/reset_password';
import ResetPasswordForm from 'components/user/authorization/reset_password_form';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid, Stack } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import { CardOptionTypography } from 'components/styles_components/typography';
import { LoginLink } from 'utils/link';
import { DividerContainer } from 'components/styles_components/container';

const ResetPassword = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { token } = useParams();

  const [resetMutation, { loading }] = useMutation(ResetMutation, {
    onCompleted: () => {
      navigate(LoginLink());
    },
  });

  return (
    <Stack>
      <CardOptionTypography variant="h5" align="left">
        <FormattedMessage id="header.user.reset_password" />
      </CardOptionTypography>
      <DividerContainer />
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <ResetPasswordForm
          initialValues={{
            email: '',
            password: '',
            token: token,
          }}
          onSubmit={(values, { setFieldError }) => {
            resetMutation({ variables: values }).catch(() => {
              setFieldError('password', intl.formatMessage({ id: 'error.user.reset_password' }));
            });
          }}
          processing={loading}
        />
      </Grid>
    </Stack>
  );
};

export default ResetPassword;
